class WciOrthoSurgeryVisitModel {
  constructor(visitNumber, dateOfProcedure) {
    this.visitNumber = visitNumber;
    this.dateOfProcedure = dateOfProcedure;
  }
}

export default WciOrthoSurgeryVisitModel;
